import {
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core'
import { FormControl } from '@angular/forms'
import { LabelToId } from 'src/app/common/input-utils'

const PILL_VALUES = [true, false]

// Binary Yes/No pill control (DESIGN.md "Pill choice" spec) — real <button role="radio"> options
// inside a role="radiogroup" container, replacing Step 1's hand-rolled mat-radio-group (story e8-2
// Task 3) and used by Step 2's Applying for NDIS / Private health insurance fields.
@Component({
  selector: 'app-pill-choice',
  templateUrl: './pill-choice.component.html',
  styleUrls: ['./pill-choice.component.scss'],
  standalone: false,
})
export class PillChoiceComponent implements OnInit {
  @Input() control: FormControl
  @Input() label: string
  @Input() required: boolean = false
  @Input() errorText: string

  @ViewChildren('pillButton') pillButtons!: QueryList<
    ElementRef<HTMLButtonElement>
  >

  id: string
  errorId: string

  ngOnInit(): void {
    this.id = LabelToId(this.label)
    this.errorId = `${this.id}-error`
  }

  get isInvalid(): boolean {
    return (
      this.required &&
      this.control?.invalid === true &&
      this.control?.touched === true
    )
  }

  isSelected(value: boolean): boolean {
    return this.control?.value === value
  }

  select(value: boolean): void {
    this.control?.setValue(value)
    this.control?.markAsTouched()
  }

  // Roving-tabindex per the WAI-ARIA radiogroup pattern: only the selected pill (or Yes, the first
  // pill, when nothing is selected yet) is a Tab stop — the other is reached via arrow keys.
  tabIndexFor(value: boolean, index: number): number {
    if (this.isSelected(value)) {
      return 0
    }
    const hasSelection = PILL_VALUES.some((candidate) =>
      this.isSelected(candidate),
    )
    return !hasSelection && index === 0 ? 0 : -1
  }

  onKeydown(event: KeyboardEvent, index: number): void {
    const arrowKeys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp']
    if (!arrowKeys.includes(event.key)) {
      return
    }
    event.preventDefault()

    const nextIndex = index === 0 ? 1 : 0
    this.select(PILL_VALUES[nextIndex])
    this.pillButtons?.toArray()[nextIndex]?.nativeElement.focus()
  }
}
